import axios from 'axios';

function handleError(e) {
    const status = e?.response?.status;
    if (status === 401 || status === 403) {
        return {
            status: false,
            error: {
                errorCode: status,
                message: "You are not authorized to perform this action. Please log in again or contact your administrator.",
            },
        };
    }
    const msg =
        e?.response?.data?.error?.message ||
        e?.response?.data?.message ||
        e?.message ||
        "Request failed";
    return { status: false, error: { message: msg } };
}

export const fetchInstanceIdsForProject = async (projectId) => {
    try {
        const response = await axios.get(`/api/dynamic-config/project/${projectId}/instances`);
        return response.data;
    } catch (e) {
        return handleError(e);
    }
};

export const fetchSchemaAndData = async (instanceId) => {
    try {
        const response = await axios.get(`/api/dynamic-config/instance/${instanceId}/schema-and-data`);
        return response.data;
    } catch (e) {
        return handleError(e);
    }
};

export const saveDynamicConfigData = async (instanceId, data) => {
    try {
        const response = await axios.post(`/api/dynamic-config/instance/${instanceId}/save`, { data });
        return response.data;
    } catch (e) {
        return handleError(e);
    }
};

export const postAssistantChat = async (instanceId, body) => {
    try {
        const response = await axios.post(`/api/dynamic-config/instance/${instanceId}/assistant`, body);
        return response.data;
    } catch (e) {
        return handleError(e);
    }
};
